import type { ButtonHTMLAttributes, PropsWithChildren } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** 占满整行 */
  block?: boolean;
}

/**
 * 按钮（主 / 次 / 危险 / 幽灵 四档，视觉上主次危险三档最常用）。
 *
 * <Button variant="primary" onClick={...}>提交</Button>
 */
export default function Button({
  variant = 'secondary',
  size = 'md',
  block,
  className,
  type = 'button',
  children,
  ...rest
}: PropsWithChildren<ButtonProps>) {
  const classes = [
    'btn',
    `btn--${variant}`,
    size !== 'md' ? `btn--${size}` : '',
    block ? 'btn--block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
